import React from "react";
import { useNavigate } from "react-router-dom";
import { FaTruckMoving, FaUser, FaBus, FaCar, FaCogs, FaTools, FaRegClipboard } from "react-icons/fa";
import styles from "./submenuope.module.css";

const Menuinformes = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Reportes</h1>
      <div className={styles.buttonGrid}>
        <button className={styles.button} onClick={() => navigate("/reporteope")}>
          <FaTruckMoving className={styles.icon} /> Reporte clientes
        </button>
        <button className={styles.button} onClick={() => navigate("/informe")}>
          <FaCogs  className={styles.icon} /> Generador de informes
        </button>
      </div>
    </div>
  );
};

export default Menuinformes;
